import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { AuxiliarReceptor } from "./auxiliarreceptor";
import { TimbradoFactura } from "./informaciontimbrado";
import { FacturaDto } from "app/models/requireme";

type Entity = models.NotaDeCredito;
export interface Props {
    value: Entity;
    dto: FacturaDto;
    onChange: (value: Entity) => PromiseLike<void> | void;
    nuevo: boolean;
    soloLectura: boolean;
}

/**
* Valida una nota de credito
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Folio: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para una nota de credito
*/
export class NotaCreditoFacturaNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, nuevo, soloLectura, dto } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Number = getField(kea.Number);

        return (
            <div>
                <kea.Title titulo="Nota de credito" onRegresar={() => history.go("/operativa/Facturas")} />

                <kea.Panel title="Factura original">
                    {kea.autogrid(3, [
                        <kea.Text label="Folio" value={dto.FolioFacturaOriginal} readonly />,
                    ])}
                </kea.Panel>
            </div>);
    }
}

export const NotaCreditoFactura = componentToRx(NotaCreditoFacturaNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/componentes/informacionnotadecredito.tsx